"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*

276 ······Pre(ProjectOperator) [tag:open, metric:count=1, sum=74020ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
277 ·····AggregateOperator[id=410] [tag:open, metric:count=1, sum=74021ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
278 ····LimitOperator[id=844] [tag:open, metric:count=1, sum=74021ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
281 ······LimitOperator[id=845] [tag:open, metric:count=1, sum=1ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
282 ·····ProjectOperator[id=1735] [tag:open, metric:count=1, sum=1ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
283 ····ProjectOperator[id=1736] [tag:open, metric:count=1, sum=1ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
284 ···UnionOperator[id=416] [tag:open, metric:count=1, sum=74023ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
285 ··LimitOperator[id=419] [tag:open, metric:count=1, sum=74023ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
286 ·ProjectOperator[id=1737] [tag:open, metric:count=1, sum=74023ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
287 OutputOperator [tag:open, metric:count=1, sum=74023ms] [tag:next, metric:count=0, sum=0ms]  rows=0 cols=0
to treeList
*/
var mark;
function getDataList(data) {
  data = data.trim();
  const dataList = data.split('\n');
  return dataList;
}
function getDataDeep(dataLine) {
  if (dataLine === undefined || dataLine === '') {
    return 0;
  }
  dataLine = dataLine.trim();
  var dataList = dataLine.split(' ');
  //如果第一个元素是数字，移掉
    if (!isNaN(dataList[0])) {
        dataList.shift();
    }
    // 拼回字符串
    dataLine = dataList.join(' ');
  for (var i = 0; i < dataLine.length; i++) {
    if (dataLine[i] !== '·') {
      return i;
    }
  }
}
function Data2Tree(data) {
  const dataList = getDataList(data);
  mark = dataList.length - 1;
  let parentNode = {
    title: dataList[mark],
    key: dataList[mark],
    children: []
  };
  let childrenNode = getSonNode(dataList, mark, --mark);
  if (childrenNode !== null) {
    parentNode.children.push(childrenNode);
  }
  return [parentNode];
}
// index 子节点坐标
function getSonNode(dataList, parent, index) {
  if (index < 0) {
    mark--;
    return null;
  }
  const sonNodes = [];
  const node = {
    title: dataList[index],
    key: dataList[index],
    children: []
  };
  if (getDataDeep(dataList[index]) <= getDataDeep(dataList[parent])) {
    mark++;
    return null;
  }
  if (mark > 0) {
    mark--;
    let leftSonNode = getSonNode(dataList, index, mark);
    if (leftSonNode !== null) {
      sonNodes.push(leftSonNode);
    }
    mark--;
    let rightSonNode = getSonNode(dataList, index, mark);
    if (rightSonNode !== null) {
      sonNodes.push(rightSonNode);
    }
  }
  node.children = sonNodes;
  return node;
}
var _default = exports.default = {
  getDataList: getDataList,
  getNode: getSonNode,
  Data2Tree: Data2Tree,
  getDataDeep: getDataDeep
};